import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../Assessts/newlogo.png";
import QR from "../Assessts/QR.png";
import bgImage from "../Assessts/pendrive images/footer1.jpeg";
import companyProfile from "../Assessts/companyprofile.pdf"; 


export default function Footer() {
  const [showContactCard, setShowContactCard] = useState(false);
  // const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
const [showWhatsappTooltip, setShowWhatsappTooltip] = useState(false);


  //Function to trigger for download  the company profile
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = companyProfile;
    link.download = "TAAD_Company_Profile.pdf"; 
    link.click();
  };

  return (
    <footer
      style={{
        width: "100%",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#fff",
        fontFamily: "Poppins, Arial, sans-serif",
        marginTop: "60px",
        position: "relative",
      }}
    >
      {/* --- Top Social Bar --- */}
      <div
        style={{
          backgroundColor: "#155382",
          textAlign: "center",
          padding: "10px 0",
        }}
      >
        {[
          {
            href: "https://www.linkedin.com/company/technocrat-aerospace-and-defence/about/?viewAsMember=true",
            src: "https://cdn-icons-png.flaticon.com/512/145/145807.png",
            alt: "LinkedIn",
          },
          {
            href: "https://x.com/taad_official",
            src: "https://cdn-icons-png.flaticon.com/512/733/733579.png",
            alt: "Twitter",
          },

          {
            href: "https://www.instagram.com/taad_official/",
            src: "https://cdn-icons-png.flaticon.com/512/2111/2111463.png",
            alt: "Instagram",
          },

          {
            href: "https://www.facebook.com/profile.php?id=61579445490586",
            src: "https://cdn-icons-png.flaticon.com/512/733/733547.png",
            alt: "Facebook",
          },
          
        ].map((item, index) => (
          <a
            key={index}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ margin: "0 10px" }}
          >
            <img src={item.src} alt={item.alt} width="24" />
          </a>
        ))}
      </div>

      {/* --- Main Footer Section --- */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          alignItems: "center",
          justifyContent: "center",
          padding: "50px 8%",
          gap: "20px",
          textAlign: "center",
        }}
      >
        {/* Left: Logo */}
        <div style={{ textAlign: "left" }}>
          <img
            src={logo}
            alt="Technocrat Logo"
            width="130"
            style={{
              marginLeft: "-120px",
              marginBottom: "-275px",
              borderRadius: "8px",
            }}
          />
        </div>

        {/* Middle: Quick Links */}
        <div>
          <h4
            style={{
              color: "#fff",
              borderLeft: "3px solid skyblue",
              paddingLeft: "10px",
              marginBottom: "15px",
              display: "inline-block",
              textAlign: "left",
            }}
          >
            Quick Links
          </h4>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              textAlign: "left",
              alignItems: "center",
            }}
          >
            {[
              { name: "Home", path: "/" },
              { name: "About", path: "/about" },
              { name: "Founder", path: "/founder" },
              { name: "Careers", path: "/careers" },
              { name: "Contact", path: "/contact" },
              { name: "Privacy Policy", path: "/privacy-policy" },
            ].map((link, i) => (
              <Link
                key={i}
                to={link.path}
                style={{
                  color: "white",
                  textDecoration: "none",
                  fontSize: "15px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.color = "skyblue")}
                onMouseLeave={(e) => (e.target.style.color = "white")}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>

        {/* Right: QR + Buttons */}
        <div style={{ textAlign: "left", marginLeft: "100px" }}>
          <img
            src={QR}
            alt="QR Code"
            width="120"
            style={{
              border: "2px solid white",
              borderRadius: "8px",
              background: "#fff",
              padding: "6px",
              marginBottom: "10px",
              marginLeft: "10px",
            }}
          />
          <br />

          {/* Contact Info Button */}
          <button
            onClick={() => setShowContactCard(true)}
            style={{
              backgroundColor: "#155382",
              color: "white",
              border: "none",
              padding: "10px 24px",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "600",
              transition: "0.3s",
              display: "block",
              marginBottom: "10px",
            }}
            onMouseEnter={(e) =>
              (e.target.style.backgroundColor = "skyblue")
            }
            onMouseLeave={(e) =>
              (e.target.style.backgroundColor = "#155382")
            }
          >
            Contact Info
          </button>

          {/* ✅ Product Info Button */}
          <button
            onClick={handleDownload}
            style={{
              backgroundColor: "#155382",
              color: "white",
              border: "none",
              padding: "10px 24px",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "600",
              transition: "0.3s",
              display: "block",
            }}
            onMouseEnter={(e) =>
              (e.target.style.backgroundColor = "skyblue")
            }
            onMouseLeave={(e) =>
              (e.target.style.backgroundColor = "#155382")
            }
          >
            Download Catalogue
          </button>
        </div>
      </div>

      {/* --- Contact Info Popup --- */}
      {showContactCard && (
        <div
          style={{
            position: "fixed",
            bottom: "100px",
            right: "50px",
            backgroundColor: "#1f1f1f",
            border: "2px solid skyblue",
            borderRadius: "12px",
            padding: "20px",
            color: "white",
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
            width: "300px",
            zIndex: 200,
          }}
        >
          <h4 style={{ color: "skyblue", marginBottom: "10px" }}>
            Contact Information
          </h4>
          <p>
            <strong>Corporate Address:</strong> <br />
            11B, 9th Floor, Urbtech NPX, Sector 153, Noida, U.P. 201310
          </p>
          <p>
            <strong>Registered Address:</strong> <br />
            419, Eldeco Udyan - 1, Behind Bangla Bazar, Lucknow 226002
          </p>
          <p>
            <strong>Contact:</strong> +91-9235352625 , +91-8595051974
          </p>
          <p>
            <strong>Email:</strong> info@taadpl.com , sales@taadpl.com
          </p>
          <button
            onClick={() => setShowContactCard(false)}
            style={{
              backgroundColor: "skyblue",
              color: "#111",
              border: "none",
              padding: "8px 14px",
              borderRadius: "6px",
              cursor: "pointer",
              marginTop: "10px",
              fontWeight: "600",
            }}
          >
            Close
          </button>
        </div>
      )}

      {/* --- Bottom Copyright --- */}
      <div
        style={{
          backgroundColor: "#111",
          textAlign: "center",
          padding: "12px 0",
          fontSize: "13px",
        }}
      >
        Copyright ©2025 - Technocrat. All Rights Reserved. Design By{" "}
        <span
          style={{
            color: "skyblue",
            fontSize: 16,
            marginLeft: 6,
            letterSpacing: 1,
            fontWeight: 600,
          }}
        >
          IT-Taad
        </span>
      </div>

      {/* --- WhatsApp Floating Button --- */}
{/* --- Catalogue Floating Button (PDF Download) --- */}
<div
  onClick={handleDownload}
  onMouseEnter={() => setShowTooltip(true)}
  onMouseLeave={() => setShowTooltip(false)}
  style={{
    position: "fixed",
    bottom: "90px",
    right: "25px",
    backgroundColor: "#155382",
    borderRadius: "50%",
    padding: "11px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    zIndex: 100,
    cursor: "pointer",
  }}
>
  <img
    // src={require("../Assessts/download.png")}
    src={require("../Assessts/downloadicon.png")}
    alt="Download Catalogue"
    width="30" 
  />

  {/* Tooltip */}
  {showTooltip && (
    <div
      style={{
        position: "absolute",
        right: "60px",
        bottom: "8px",
        backgroundColor: "#155382",
        color: "white",
        padding: "6px 12px",
        borderRadius: "6px",
        fontSize: "12px",
        whiteSpace: "nowrap",
        boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
      }}
    >
      Catalogue
    </div>
  )}
</div>








 <a
  href="https://wa.me/9235352625"
  target="_blank"
  rel="noopener noreferrer"
  onMouseEnter={() => setShowWhatsappTooltip(true)}
  onMouseLeave={() => setShowWhatsappTooltip(false)}
  style={{
    position: "fixed",
    bottom: "20px",
    right: "20px",
    backgroundColor: "#25D366",
    borderRadius: "50%",
    padding: "10px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    zIndex: 100,
    cursor: "pointer",
  }}
>
  <img
    src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
    alt="WhatsApp"
    width="35"
  />

  {/* Tooltip */}
  {showWhatsappTooltip && (
    <div
      style={{
        position: "absolute",
        right: "60px",
        bottom: "8px",
        backgroundColor: "#25D366",
        color: "white",
        padding: "6px 12px",
        borderRadius: "6px",
        fontSize: "13px",
        whiteSpace: "nowrap",
        boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
      }}
    >
      WhatsApp
    </div>
  )}
</a>

    </footer>
  );
}
